import { useTranslation } from 'react-i18next';
import { PostModal, PostModalProps } from '../shared';
import { Template, TemplatePostDetailsType, TemplateProps } from './template';

export type InfluencerInstagramAnalyticsReelDetailsModalProps = Pick<TemplateProps, 'isAnalytics'> &
  Pick<PostModalProps<TemplatePostDetailsType>, 'posts'>;

export const InfluencerInstagramAnalyticsReelDetailsModal = ({
  posts,
  isAnalytics
}: InfluencerInstagramAnalyticsReelDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={posts}>
      <PostModal.Title>{t('Post Detail')}</PostModal.Title>
      <Template isAnalytics={isAnalytics} />
    </PostModal>
  );
};
